<template>
  <div style="width: 95%; margin: 0 auto;">
    <div class="mark-header">
      <div :class="`inner-fixed-header ${statusClass}`">
        <div>
          <div>
            <span>考生姓名：{{ksksjl.yhmc}}</span>
            <span style="margin-left: 40px">用时：{{ksksjl.dtsc}}</span>
            <span style="margin-left: 40px">开始于：{{ksksjl.kssj}}</span>
            <span style="margin-left: 40px">结束于：{{ksksjl.jssj}}</span>
            <el-divider class="divider-margin"></el-divider>
          </div>
          <div>
            <span style="font-size: 20px; font-weight: bold;">成绩：{{ksksjl.zzdf}}分</span>
            <span style="margin-left: 30px">及格分数：{{ksksjl.jgfs ? ksksjl.jgfs + '分' :  '未设置'}}</span>
            <span style="font-weight: bold; font-size: 20px; padding: 5px">|</span>
            <span>总分：{{ksksjl.sjzf}}分</span>
            <div style="margin-left: 30px; display: inline-flex; align-items: center;">
              <span style="margin-right: 5px;">仅看错题</span>
              <el-switch v-model="jxsct" :active-value="true" :inactive-value="false" />
            </div>
          </div>
        </div>
        <div style="margin-left: 30px;">
          <strong style="font-size:x-large;">
            {{ statusText }}
          </strong>
          <!-- <el-row v-if="yjjl.yjlx ==='1' && yjjl.yjzt === '2' " class="ypy background">已批阅</el-row>
          <el-row v-else-if="yjjl.yjlx === '2'" :class="`${yjjl.yjzt === '2'?'yzc':''} background`">{{yjjl.yjzt === '2' ? '已仲裁' : '正在仲裁'}}</el-row>
          <el-row v-else-if="yjjl.yjlx === '3'" :class="`${ksksjl.pyzt === '2'?'yfh':''} background`">{{ksksjl.pyzt === '2' ? '已复核' : '未复核'}}</el-row> -->
        </div>
        <div style="margin-left: auto;">
          <div>
            <el-button @click="handleJump('back')">上一份</el-button>
            <el-button @click="handleJump('next')">下一份</el-button>
            <el-button :style="`visibility: ${allowEdit === 'Y' ? 'visible' : 'hidden'}`" :disabled="!allowSubmit" type="primary" @click="save">{{yjjl.yjlx === '3' ? '确认复核' : '提交评卷'}}</el-button>
          </div>
          <div v-if="sfzb" style="margin-top: 10px; padding-right: 80px">
            <span style="color: red">注意：该记录为作弊强制交卷！</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mark-ctn">
      <div class="mark-aside">
        <div class="dtTxContent" v-for="(ksySjkDt, dtIdx) in sjk.ksySjkDtList" :key="dtIdx">
          <div style="font-size: 16px; padding: 10px; text-align: left;" v-text="upperNum[dtIdx] + '.' + ksySjkDt.dtmc"></div>
          <div class="box" v-for="(ksySjkSt, stIdx) in ksySjkDt.ksySjkStList" :key="stIdx" @click="goSt(ksySjkDt.dtid, ksySjkSt.stid)"
          :style="getYjjlItem(ksySjkDt, ksySjkSt).zzdf === ksySjkSt.stfz ? 'background-color:#00cc00' : 'background-color:#ff3300'"
          >
            {{stIdx + 1}}
          </div>
        </div>
      </div>
      <div class="mark-main">
        <div v-for="(ksySjkDt, dtIdx) in sjk.ksySjkDtList" :key="dtIdx" class="dtDiv" v-show="!jxsct || checkStListOfDt(ksySjkDt.dtid)">
          <!--***** 大题 *****-->
          <el-row style="margin-bottom: 5px; padding-top: 5px">
            <strong v-text="upperNum[dtIdx] + '.' + ksySjkDt.dtmc + '（共' + ksySjkDt.ksySjkStList.length + '题，共' + ksySjkDt.dtzf + '分）'"/>
          </el-row>
          <div v-for="(ksySjkSt, stIdx) in ksySjkDt.ksySjkStList" :key="stIdx" v-show="!jxsct || getYjjlItem(ksySjkDt, ksySjkSt).zzdf !== ksySjkSt.stfz">
            <template v-if="ksySjkSt.tx !== '9'">
              <div class="stDiv">
                <!--***** 题干 *****-->
                <el-row style="padding: 10px 0px;">
                  <el-col :span="17">
                    <el-col style="width: 10px; margin-right: 10px; padding-top: 3px;">{{stIdx+1}}. </el-col>
                    <el-col :span="20">
                      <pre class="editorHtml" v-html="(ksySjkSt.stnr || ksySjkSt.tg) + `（${ksySjkSt.stfz}分）`"></pre>
                    </el-col>
                  </el-col>
                  <el-col :span="7" style="text-align: right" :style="`pointer-events: ${allowEdit === 'Y' ? 'auto' : 'none'}`" >
                    <div class="box box1" @click="right($event, ksySjkSt.stfz, ksySjkDt.dtid, ksySjkSt.stid)" :style="getYjjlItem(ksySjkDt, ksySjkSt).zzdf=== ksySjkSt.stfz ? 'background-color:#00cc00' : 'background-color:silver; opacity:0.5'">✔</div>
                    <div class="box box2" @click="error($event, 0, ksySjkDt.dtid, ksySjkSt.stid)" :style="getYjjlItem(ksySjkDt, ksySjkSt).zzdf !== ksySjkSt.stfz ? 'background-color:#ff3300' : 'background-color:silver; opacity:0.5'">✘</div>
                    <el-input-number :id="ksySjkDt.dtid+'-'+ksySjkSt.stid" @change="(currentValue, oldValue) => stfzChange(ksySjkDt.dtid, ksySjkSt.stid, currentValue, oldValue)" v-model="yjjl.ksyYjjlxqList[jlxqIndex(ksySjkDt.dtid, ksySjkSt.stid)].zzdf" :min="0" :max="ksySjkSt.stfz" :precision="1" label="请输入分数"></el-input-number>分
                  </el-col>
                </el-row>
                 <!--***** 选项 *****-->
                <!--单选题 -->
                <el-row v-if="ksySjkSt.tx === '1'">
                  <div v-for="(ksySjkStxx, stxxIdx) in ksySjkSt.ksySjkStxxList" :key="stxxIdx" style="margin-bottom: 15px;">
                    <el-radio onclick="return false" v-model="ksySjkSt.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" style="width: 40px; margin-right: 5px;">
                      {{options[stxxIdx]}}.
                    </el-radio>
                    <pre class="editorHtml" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm"></pre>
                  </div>
                </el-row>
                <!--多选题 -->
                <el-row v-if="ksySjkSt.tx === '2'">
                  <div v-for="(ksySjkStxx, stxxIdx) in ksySjkSt.ksySjkStxxList" :key="stxxIdx" style="margin-bottom: 15px;">
                    <el-checkbox onclick="return false" v-model="ksySjkSt.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" style="width: 40px; margin-right: 5px;">
                      {{options[stxxIdx]}}.
                    </el-checkbox>
                    <pre class="editorHtml" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm"></pre>
                  </div>
                </el-row>
                <!--判断题 -->
                <el-row v-if="ksySjkSt.tx === '4'">
                  <div v-for="(ksySjkStxx, stxxIdx) in ksySjkSt.ksySjkStxxList" :key="stxxIdx" style="margin-bottom: 15px;">
                    <el-radio onclick="return false" v-model="ksySjkSt.ksySjkStda.ksda" :label="ksySjkStxx.xxid + ''" style="width: 40px; margin-right: 5px;">
                      {{options[stxxIdx]}}.
                    </el-radio>
                    <pre class="editorHtml" v-html="ksySjkStxx.xxnr || ksySjkStxx.xxsm"></pre>
                  </div>
                </el-row>
                <!--录音题 -->
                <el-row v-if="ksySjkSt.tx === '6'">
                  <div v-for="(audio, k) in audioList.filter(a => a.stid === ksySjkSt.stid)" :key="k">
                    <audio style="height: 50px; line-height: 50px;"
                      :src="baseURL + `/examineeAnswer/audio/${ksid_init}/${lsh_init}/${audio.name}`"
                      controls
                      preload="metadata"
                      ref="audio"
                    >您的浏览器不支持音频元素</audio>
                  </div>
                </el-row>
                <!--***** 答案 *****-->
                <div style="margin: 10px; padding: 10px; background: #FAFAFA;">
                  <el-row v-if="ksySjkSt.tx === '1' || ksySjkSt.tx === '2'" style="padding: 10px 0px;">
                    <span style="margin-right: 20px">标准答案：{{parseABC(ksySjkSt.ksySjkStda.bzda, ksySjkSt.ksySjkStxxList)}}</span>
                    考生答案：<span :style="getYjjlItem(ksySjkDt, ksySjkSt).zzdf === ksySjkSt.stfz ? 'color:#00cc00' : 'color:#ff3300'">{{parseABC(ksySjkSt.ksySjkStda.ksda, ksySjkSt.ksySjkStxxList)}}</span>
                  </el-row>
                  <template v-else-if="ksySjkSt.tx === '3'">
                    <el-row style="padding: 10px 0px;">
                      <el-col style="width: 80px">考生答案：</el-col>
                      <el-col :span="20">
                        <span v-html="ksySjkSt.ksySjkStda.ksda.join('<br/>')" :style="getYjjlItem(ksySjkDt, ksySjkSt).zzdf === ksySjkSt.stfz ? 'color:#00cc00' : 'color:#ff3300'"></span>
                      </el-col>
                    </el-row>
                    <el-row style="padding: 10px 0px;">
                      <el-col style="width: 80px">标准答案：</el-col>
                      <el-col :span="20">
                        <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.bzda.split('€').join('<br/>')"></pre>
                      </el-col>
                    </el-row>
                  </template>
                  <el-row v-else-if="ksySjkSt.tx === '4'" style="padding: 10px 0px;">
                    <span style="margin-right: 20px">
                      标准答案：{{parseXxsm(ksySjkSt.ksySjkStda.bzda, ksySjkSt.ksySjkStxxList)}}
                    </span>
                    考生答案：<span :style="getYjjlItem(ksySjkDt, ksySjkSt).zzdf === ksySjkSt.stfz ? 'color:#00cc00' : 'color:#ff3300'">{{parseXxsm(ksySjkSt.ksySjkStda.ksda, ksySjkSt.ksySjkStxxList)}}</span>
                  </el-row>
                  <el-row v-else-if="ksySjkSt.tx === '6'" style="padding: 10px 0px;">
                    <el-col style="width: 80px">标准答案：</el-col>
                    <el-col :span="20">
                      <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.bzda"></pre>
                    </el-col>
                  </el-row>
                  <template v-else>
                    <el-row style="padding: 10px 0px;">
                      <el-col style="width: 80px">考生答案：</el-col>
                      <el-col :span="20">
                        <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.ksda || '<br/>'"></pre>
                        <img-preview v-if="fileList.length > 0" :ksid="ksid_init" :lsh="lsh_init" :stid="ksySjkSt.stid" :fileList="fileList"></img-preview>
                      </el-col>
                    </el-row>
                    <el-row style="padding: 10px 0px;">
                      <el-col style="width: 80px">标准答案：</el-col>
                      <el-col :span="20">
                        <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.bzda"></pre>
                      </el-col>
                    </el-row>
                  </template>
                  <!--***** 答案解析 *****-->
                  <el-row style="padding: 10px 0px;">
                    <el-col style="width: 80px">答案解析：</el-col>
                    <el-col :span="20">
                      <pre class="editorHtml" v-html="ksySjkSt.ksySjkStda.dajx || '无'" ></pre>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import * as markingPaper from '@/api/markingPaper'
import ImgPreview from '@/components/examineeAnswer/ImgPreview'
import { getAudioList, getFileList } from '@/api/examineeAnswer'
import { baseURL } from '@/assets/js/config.js'
export default {
  inject: ['reload'],
  data () {
    return {
      baseURL: baseURL,
      jxsct: false,
      options: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      upperNum: ['一', '二', '三', '四', '五', '六', '七', '八', '九', '十'],
      ksid_init: null, // 默认的考试ID
      sjid_init: null, // 默认的试卷ID
      lsh_init: null, // 默认的流水号
      allowEdit: 'Y', // 允许编辑
      allowSubmit: true, // 允许提交
      ksksjl: {}, // 考试记录
      sjk: {}, // 试卷
      yjjl: {}, // 阅卷记录
      fileList: [], // 录音列表
      audioList: [] // 录音列表
    }
  },
  computed: {
    sfzb () {
      return this.ksksjl.qzjj?.indexOf('作弊') !== -1
    },
    statusText () {
      if (this.yjjl.yjlx === '1' && this.yjjl.yjzt === '2') {
        return '已批阅'
      } else if (this.yjjl.yjlx === '2') {
        if (this.yjjl.yjzt === '2') {
          return '已仲裁'
        } else {
          return '正在仲裁'
        }
      } else if (this.yjjl.yjlx === '3') {
        if (this.ksksjl.pyzt === '2') {
          return '已复核'
        } else {
          return '未复核'
        }
      } else {
        return ''
      }
    },
    statusClass () {
      if (this.yjjl.yjlx === '1' && this.yjjl.yjzt === '2') {
        return 'ypy'
      } else if (this.yjjl.yjlx === '2') {
        if (this.yjjl.yjzt === '2') {
          return 'yzc'
        } else {
          return ''
        }
      } else if (this.yjjl.yjlx === '3') {
        if (this.ksksjl.pyzt === '2') {
          return 'yfh'
        } else {
          return ''
        }
      } else {
        return ''
      }
    }
  },
  components: {
    ImgPreview
  },
  methods: {
    getYjjlItem (ksySjkDt, ksySjkSt) {
      const index = this.jlxqIndex(ksySjkDt?.dtid, ksySjkSt?.stid)
      return this.yjjl.ksyYjjlxqList[index] || {}
    },
    getFileList (ksid, lsh) {
      getFileList({ ksid: ksid, lsh: lsh }).then(res => {
        this.$http.callback(res, () => {
          this.fileList = res.data
        })
      })
    },
    getAudioList (ksid, lsh) {
      getAudioList({ ksid: ksid, lsh: lsh }).then(res => {
        this.$http.callback(res, () => {
          this.audioList = res.data
        })
      })
    },
    toMarkingPaper () {
      const query = {
        ksid: this.ksid_init
      }
      this.$router.push({
        path: '/markingPaper/list',
        query: query
      })
    },
    goSt (dtid, stid) {
      document.getElementById(dtid + '-' + stid).querySelector('.el-input__inner').focus()
    },
    right (e, stfz, dtid, stid) {
      e.currentTarget.style.backgroundColor = '#00cc00'
      e.currentTarget.nextElementSibling.style.backgroundColor = ''
      this.yjjl.ksyYjjlxqList[this.jlxqIndex(dtid, stid)].zzdf = stfz
      this.stfzChange()
    },
    error (e, stfz, dtid, stid) {
      e.currentTarget.style.backgroundColor = '#ff3300'
      e.currentTarget.previousElementSibling.style.backgroundColor = ''
      this.yjjl.ksyYjjlxqList[this.jlxqIndex(dtid, stid)].zzdf = stfz
      this.stfzChange()
    },
    // 根据大题ID 判断大题内的试题是否有错误
    checkStListOfDt (dtid) {
      const ksySjkDt = this.sjk.ksySjkDtList.find(ksySjkDt => ksySjkDt.dtid === dtid)
      const ksyYjjlxqList = this.yjjl.ksyYjjlxqList.filter(ksyKsksjlxqL => ksyKsksjlxqL.dtid === dtid)
      for (const stIdx in ksySjkDt.ksySjkStList) {
        const ksySjkSt = ksySjkDt.ksySjkStList[stIdx]
        for (const xqIdx in ksyYjjlxqList) {
          const ksyYjjlxq = ksyYjjlxqList[xqIdx]
          if (ksySjkSt.stid === ksyYjjlxq.stid && ksySjkSt.stfz !== ksyYjjlxq.zzdf) {
            return true
          }
        }
      }
    },
    // 根据题目ID 获取该题目再考生记录详情列表中的位置
    jlxqIndex (dtid, stid, xtid) {
      // console.log(this.sjk.ksySjkDtList)
      // console.log(dtid, stid, xtid)
      xtid = xtid || '0'
      const ksyYjjlxqList = this.yjjl.ksyYjjlxqList
      if (ksyYjjlxqList && ksyYjjlxqList.length > 0) {
        for (const index in ksyYjjlxqList) {
          const ksyYjjlxq = ksyYjjlxqList[index]
          if (ksyYjjlxq.dtid === dtid && ksyYjjlxq.stid === stid && ksyYjjlxq.xtid === xtid) {
            // console.log('index:', index)
            return index
          }
        }
      }
      // console.log('没有找到')
      // return 0
    },
    // 试题分数改变时触发
    stfzChange (dtid, stid, currentValue, oldValue) {
      // 如果把值删除了 则还原成原来的值
      if (dtid && stid && currentValue === undefined) {
        setTimeout(() => {
          this.yjjl.ksyYjjlxqList[this.jlxqIndex(dtid, stid)].zzdf = oldValue
        }, 100)
      }
      let zzdf = 0.0
      this.yjjl.ksyYjjlxqList.forEach(ksyYjjlxq => {
        zzdf += (ksyYjjlxq.zzdf || 0.0)
      })
      this.ksksjl.zzdf = zzdf
    },
    // 将标准答案 转换成 ABC
    parseABC (da, xxList) {
      if (!da) {
        return ''
      }
      if (!Array.isArray(da)) {
        da = da.split('€')
      }
      const results = da.map(xxid => {
        const xxIndex = xxList.findIndex(xxObj => Number(xxObj.xxid) === Number(xxid))
        return xxIndex !== undefined && xxIndex !== -1 ? this.options[xxIndex] : '-'
      })
      return results.sort().join(',')
    },
    parseXxsm (bzda, xxList) {
      const xx = xxList.find(xxObj => Number(xxObj.xxid) === Number(bzda))
      return xx ? xx.xxsm : '-'
    },
    getSjkDetail () {
      const params = { sjid: this.sjid_init, lsh: this.lsh_init }
      markingPaper.detail(params).then(res => {
        this.$http.callback(res, () => {
          this.ksksjl = res.data.ksksjl || null // 考试记录
          this.sjk = res.data.ksySjk || null // 试卷详情
          this.yjjl = res.data.ksyYjjl // 阅卷记录
          this.allowEdit = res.data.allowEdit // 允许编辑
        })
      })
    },
    // 上一份、下一份
    handleJump (handleType) {
      const params = { ksid: this.ksid_init, lsh: this.lsh_init, handleType: handleType }
      markingPaper.getListData(params).then(res => {
        this.$http.callback(res, () => {
          if (res.data && res.data.length > 0) {
            const query = {
              ksid: this.ksid_init,
              sjid: res.data[0].sjid,
              lsh: res.data[0].lsh
            }
            this.$router.push({
              path: '/markingPaper/marking',
              query: query
            })
            this.reload()
          } else {
            this.$message.warning('已经到底了')
          }
        })
      })
    },
    save () {
      this.allowSubmit = false
      markingPaper.save(this.yjjl).then(res => {
        this.$http.callback(res, () => {
          this.$message.success(res.msg)
          this.reload()
        })
      })
    }
  },
  created () {
    this.ksid_init = this.$route.query.ksid
    this.sjid_init = this.$route.query.sjid
    this.lsh_init = this.$route.query.lsh
    this.getSjkDetail()
  },
  mounted () {
    // 获取附件列表
    this.getFileList(this.ksid_init, this.lsh_init)
    // 获取音频列表
    this.getAudioList(this.ksid_init, this.lsh_init)
  }
}
</script>
<style lang="less" scoped>
  .background {
    position:absolute;
    left:0px;
    top:0px;
    width:100%;
    height:95px;
    line-height:95px;
    z-index:-1;
    color:#999999;
    padding-top: 25px;
    font-size: 40px;
    text-align: center;
  }
  .ypy {
    background-color: #9baef0;
  }
  .yzc {
    background-color: #a6bad6;
  }
  .yfh {
    background-color: #C1FFC1;
  }
  .dtTxContent {
    border-bottom: 1px solid #e6e6e6;
    margin-top: 5px;
    width: 100%;
    text-align: left;
    .box {
      display: inline-block;
      text-align: center;
      margin: 5px 5px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      border: 1px solid;
      color: white;
      cursor: pointer;
    }
    .box:hover {
      border-color: blue;
    }
  }
  .dtDiv {
    margin-bottom: 20px;
    position: relative;
    padding: 0px 10px;
    .stDiv {
      background-color: #ffffff;
      position: relative;
      margin: 10px 0px;
      padding: 5px 10px;
      .box {
        display: inline-block;
        text-align: center;
        margin: 5px 10px;
        width: 30px;
        height: 30px;
        line-height: 30px;
        border-radius: 50%;
        /*border: 1px solid;*/
        border: 0;
        color: white;
        box-shadow: 0 0 10px #1E1E1E;
      }
      .box1:hover {
        box-shadow: 0 0 10px #00cc00;
      }
      .box2:hover {
        box-shadow: 0 0 10px #ff3300;
      }
    }
  }

  .mark-header{
    // height: 95px;
    height: 95px;
    .inner-fixed-header{
      width: 95%;
      height: 90px;
      margin: 0  0 5px 0;
      padding: 10px;
      position: fixed;
      top: 0;
      z-index: 2;
      background-color: #fff;

      display: flex;
      align-items: center;
    }
  }

  .mark-ctn{
    display: flex;
    .mark-aside{
      position: fixed;
      top: 95px;
      height: 86%;
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 0 6px #eee;
      overflow: auto;
      width: 240px;
    }
    .mark-main{
      margin-left: auto;
      width: calc(100% - 240px);
    }
  }

  .divider-margin{
    margin: 5px 0;
  }
</style>
